import React from "react";
import { ClassNameProps, dateTrunc, Heading, Section, StyleProps, toLocalDateString } from "@hex-insights/core";
import { CalendarEventResponseResponse, useCalendarEventListQuery } from "../../../../Utilities";
import { SharingPolicyUtilities } from "../../../Utilities";
import { CalendarEventList } from "../List";

export type UpcomingEventsProps = Partial<ClassNameProps & StyleProps>;

export function UpcomingEvents({ className, style }: UpcomingEventsProps) {
	const [now] = React.useState(() => dateTrunc(new Date(), "hour").toISOString()); // date trunc for improved caching
	const [today] = React.useState(() => toLocalDateString(new Date()));
	const { data } = useCalendarEventListQuery({
		variables: {
			filters: {
				and: [
					{
						or: [
							{ author: [{ isCurrentEQ: true }] },
							{
								sharingPolicy: [SharingPolicyUtilities.viewerSharingPolicyFilter],
							},
							{
								calendarEventResponses: [
									{
										author: [{ isCurrentEQ: true }],
										responseIn: [CalendarEventResponseResponse.Attending, CalendarEventResponseResponse.MaybeAttending],
									},
								],
							},
						],
					},
					{
						or: [{ startTimeGTE: now }, { startDateGTE: today }],
					},
				],
			},
		},
	});

	return (
		<Section className={className} style={style}>
			<Section.Header>
				<Heading.H3 noMargin style={{ textAlign: "center" }}>
					Upcoming Events
				</Heading.H3>
			</Section.Header>
			<Section.Body style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 0 }}>
				<CalendarEventList
					calendarEventEdges={data?.calendarEventConnection.edges}
					numDisplayed={4}
					noEventsDisplay="No Upcoming Events"
				/>
			</Section.Body>
		</Section>
	);
}
